module.exports = __webpack_public_path__ + "close.svg?f8962ec85de092db7f71e8fc2a546911";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.svg
// module id = 44
// module chunks = 6